import { createContext } from 'use-context-selector';
import { ADTO, CDTO } from '@helpful/network';

interface DetailsContextProps {
  loading: boolean;
  uncomleted?: ADTO.SurveyEntity;
  survey: CDTO.GetSurveyQuery['surveyCollection']['items']['0'];
}

export const DetailsContext = createContext<DetailsContextProps>({
  survey: null,
  loading: false,
});
